module.exports = __webpack_public_path__ + "static/selune-symbol-DND3_FnP-3888e97a8ed077442200f34b36a5e749.jpg";